import React, { Component } from 'react'
import { translate } from 'react-i18next'
import { compose } from 'react-apollo'
import moment from 'moment'

import config from '../../config'

import { Carousel } from 'react-responsive-carousel'
import 'react-responsive-carousel/lib/styles/carousel.css'
import getSymbolFromCurrency from 'currency-symbol-map'

class BookingSummary extends Component {
  constructor(props) {
    super(props)

    this.state = {
      detailsShown: true
    }
  }

  componentDidMount() {
    if (window.innerWidth > 767) {
      this.setState({ detailsShown: true })
    } else this.setState({ detailsShown: false })

    window.addEventListener('resize', () => {
      if (window.innerWidth > 767) {
        this.setState({ detailsShown: true })
      }
    })
  }

  viewDetails() {
    this.setState({
      detailsShown: !this.state.detailsShown
    })
  }

  componentWillUnmount() {
    window.removeEventListener('resize')
  }

  render() {
    const { summary, activity, saveBookingSteps, t } = this.props

    let travelers

    if (!summary.travelers.length) {
      travelers = summary.partySize ? 'You + ' + summary.partySize : 'You'
    } else {
      travelers = summary.travelers.length ? 'You + ' + summary.travelers.length : 'You'
    }

    const amountOfPeople = summary.partySize ? summary.partySize + 1 : summary.travelers.length + 1

    let price = summary.privateTour ? activity.privateTourPrice : activity.groupPrice

    let result = summary.privateTour ? activity.privateTourPrice : price * amountOfPeople

    const serviceFee = result * config.activityServiceFee;

    const resultWithFee = result + serviceFee

    const expression = `${price} X ${amountOfPeople} = ${result}${getSymbolFromCurrency(activity.currency)}`

    return (
      <div className="summary">
        <div className="side-info">
          {activity.photos && (
            <Carousel showArrows={true} showStatus={false} showThumbs={false} autoPlay={true} emulateTouch={true}>
              {activity.photos.map((photo, index) => (
                <div className="carouselPhoto" key={index}>
                  <img src={photo.url} alt="" />
                </div>
              ))}
            </Carousel>
          )}
          <div className={this.state.detailsShown ? 'review' : 'hidden'}>
            <div className={summary.paymentType ? 'row' : 'hidden'}>
              <div className="col-lg-12 col-md-12 col-sm-12">
                <button className="action-button summary__action-button" onClick={saveBookingSteps}>
                  {t('place_order')}
                </button>
              </div>
            </div>
            <h2 className="section title">{t('review_summary')}</h2>

            <div className="row summary__item">
              <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                <span className="summary__item__title">{t('your_activity')}:</span>
              </div>
              <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 text-right">
                <span className="summary__item__value">{activity.title}</span>
              </div>
            </div>
            <div className="row summary__item">
              <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                <span className="summary__item__title">{t('start_date')}:</span>
              </div>
              <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 text-right">
                <span className="summary__item__value">{moment(summary.startDate).format('MM/DD/YYYY hh:mm A')}</span>
              </div>
            </div>

            <div className="row summary__item">
              <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                <span className="summary__item__title">{t('coming')}</span>
              </div>
              <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 text-right">
                <span className="summary__item__value">{travelers}</span>
              </div>
            </div>

            <div className={summary.group ? 'summary__item row' : 'hidden'}>
              <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                <span className="summary__item__title">{t('summary_group')}</span>
              </div>
              <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 text-right">
                <span className="summary__item__value">{summary.group}</span>
              </div>
            </div>

            <div className={summary.tripTempo ? 'summary__item row' : 'hidden'}>
              <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                <span className="summary__item__title">{t('summary_tempo')}</span>
              </div>
              <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 text-right">
                <span className="summary__item__value">{summary.tripTempo}</span>
              </div>
            </div>
            <div className={summary.requestedBudgetMin ? 'summary__item row' : 'hidden'}>
              <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                <span className="summary__item__title">{t('summary_budget_min')}</span>
              </div>
              <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 text-right">
                <span className="summary__item__value">{summary.requestedBudgetMin}</span>
              </div>
            </div>
            <div className={summary.requestedBudgetMax ? 'summary__item row' : 'hidden'}>
              <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                <span className="summary__item__title">{t('summary_budget_max')}</span>
              </div>
              <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 text-right">
                <span className="summary__item__value">{summary.requestedBudgetMax}</span>
              </div>
            </div>
            <div className={summary.tripBudgetTypeValue ? 'summary__item row' : 'hidden'}>
              <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                <span className="summary__item__title">{t('summary_budget_type')}</span>
              </div>
              <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 text-right">
                <span className="summary__item__value">{summary.tripBudgetTypeValue}</span>
              </div>
            </div>

            <div className={summary.privateTour ? 'summary__item row' : 'hidden'}>
              <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                <span className="summary__item__title">{t('private_tour_price')}</span>
              </div>
              <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 text-right">
                <span className="summary__item__value">{`${activity.privateTourPrice}${getSymbolFromCurrency(activity.currency)}`}</span>
              </div>
            </div>

            <div className={summary.paymentType ? 'summary__item row' : 'hidden'}>
              <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                <span className="summary__item__title">{t('summary_payment')}</span>
              </div>
              <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 text-right">
                <span className="summary__item__value">{summary.paymentType}</span>
              </div>
            </div>

            <div className={!summary.privateTour ? 'summary__item row' : 'hidden'}>
              <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                <span className="summary__item__title show-mobile">{t('total')}</span>
              </div>
              <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 text-right">
                <span className="summary__item__value">{expression}</span>
              </div>
            </div>

            <hr />

            <div className="row summary__item">
            <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">
              <span className="summary__item__title">{t('booking_steps:service_fee')}:</span>
            </div>
            <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 text-right">
              <span className="summary__item__value">
              {`${serviceFee}${getSymbolFromCurrency(activity.currency)}`}
              </span>
            </div>
          </div>

          </div>

          <div className="summary__item total-wrapper row">
            <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
              <span className="summary__item__title total-block hide-mobile">{t('total')}</span>

              <div className="show-mobile result-mobile">
                <span className="summary__item__value total">{`${resultWithFee}${getSymbolFromCurrency(activity.currency)}`}</span>
                <button className="view-details" onClick={() => this.viewDetails()}>
                  {t('view_details')}
                </button>
              </div>
            </div>
            <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
              <span className="summary__item__value total hide-mobile">{`${resultWithFee}${getSymbolFromCurrency(activity.currency)}`}</span>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const enhance = compose(translate('activity_booking_steps'))

export default enhance(BookingSummary)



// WEBPACK FOOTER //
// src/components/Activity/BookingSummary.jsx